/* eslint-disable import/prefer-default-export */
export const getSelectedSuppliers = state => state.selectedSuppliers
export const getListsParams = state => state.listsParams
export const getTabs = state => state.tabs
export const getColumnsList = state => state.columnsList
